import type { JobDetailData } from "@apis/videoCreatingService";
import type { VideoGenerateRecord } from "@pages/library/librarySlice";

export const ASPECT_RATIO_MAP: Record<string, string> = {
  RATIO_9_16: "9:16",
  RATIO_16_9: "16:9",
};

export const formatDate = (date?: number | string) => {
  if (!date) return "-";
  const d = new Date(typeof date === "number" ? date : date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year} / ${month} / ${day}`;
};

type VideoGenerateRecordWithUrl = VideoGenerateRecord & { url?: string | null };

export const getRecordVideoUrl = (record?: VideoGenerateRecord | null) => {
  const recordWithUrl = record as VideoGenerateRecordWithUrl | undefined | null;
  return recordWithUrl?.jobItem?.context?.videoUrl || recordWithUrl?.url || undefined;
};

export const getVideoUrl = (jobDetail: JobDetailData | null, record?: VideoGenerateRecord | null) => {
  return jobDetail?.output?.videoUrl || getRecordVideoUrl(record);
};

export const getAspectRatio = (jobDetail: JobDetailData | null, record?: VideoGenerateRecord | null) => {
  return jobDetail?.input?.aspectRatio || record?.jobItem?.context?.aspectRatio;
};
